<template lang="pug">
  v-card.adock-card.mt-2
    v-card-title(primary-title)
      h2 Vos messages
    v-card-text.pb-0
      | Contactez les administrateurs du site.
    v-row
      v-col(align="right")
        v-btn(
          color="primary"
          :to="{'name': 'accounts__thread_new'}"
        ) Nouveau message
    ThreadList(
      :threads-url="threadsUrl"
      :get-router-thread-url="getRouterThreadUrl"
    )
</template>

<script>
import api from "@/api";
import ThreadList from "@/components/ThreadList.vue";

export default {
  components: {
    ThreadList,
  },

  data() {
    return {
      threadsUrl: api.threadsUrl,
      getRouterThreadUrl: (threadId) => {
        return { name: "accounts__thread", params: { threadId } };
      },
    };
  },
};
</script>
